import { StatusComponent } from './Status';
import { connectStatus } from './status.connect';

export * from './status.common';
export const Status = connectStatus(StatusComponent);
